import "./CoursesListing.css";
import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import ActionConfirmation from "../../../../Components/ActionConfirmation/ActionConfirmation";
import CoursesListingViewModel from "./CoursesListingViewModel";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";

const CoursesListing = () => {
  const [
    CoursesArray,
    DeleteDialog,
    handleOpenDeleteDialog,
    handleCloseDeleteDialog,
    ClassID,
    AuthUser,
    IsLoading,
  ] = CoursesListingViewModel();

  // Course Card Dropdown Start
  const [OpenDropdown, setOpenDropdown] = useState(); // undefined is nothing open
  const toggle = (id) => setOpenDropdown(OpenDropdown === id ? undefined : id); // close if currently open
  // Course Card Dropdown End

  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper classes-and-courses-page-courses">
        {IsLoading ? (
          <PulseLoader
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "90Vh",
            }}
            color="#3D5EE1"
            size={16}
          />
        ) : (
          <div className="content container-fluid">
            {/* Page Header */}
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Courses</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <a href="#">Dashboard</a>
                    </li>
                    <li className="breadcrumb-item active">Courses</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* /Page Header */}

            <div className="row courses-row">
              {AuthUser?.UserType === "admin" && (
                <Link
                  to={`/user/admin/classes/courses/add/${ClassID}`}
                  className="col-sm-6 col-lg-4 col-xl-3 add-course"
                >
                  <i className="fa-solid fa-plus"></i>
                </Link>
              )}

              {CoursesArray &&
                CoursesArray.map((item, index) => {
                  return (
                    <div
                      key={index}
                      className="col-sm-6 col-lg-4 col-xl-3 d-flex course-card-container"
                    >
                      <div className="card invoices-grid-card w-100">
                        <div className="card-header d-flex justify-content-between align-items-center">
                          <p className="invoice-grid-link course-session">
                            ID: {item?.CourseID}{" "}
                          </p>
                          <div className="dropdown dropdown-action d-none">
                            <Link
                              onClick={() => toggle(item?.id)}
                              className="action-icon dropdown-toggle"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i className="fas fa-ellipsis-v" />
                            </Link>
                            {OpenDropdown === item?.id && (
                              <div
                                style={{
                                  display: OpenDropdown && "block",
                                  position: "absolute",
                                  right: 0,
                                }}
                                className="dropdown dropdown-menu dropdown-menu-end"
                              >
                                <Link
                                  to={`/user/admin/classes/courses/update/${item?.id}`}
                                  className="dropdown-item"
                                >
                                  <i className="far fa-edit me-2" />
                                  Edit
                                </Link>
                                <Link
                                  className="dropdown-item"
                                  to={`/user/admin/classes/courses/attendance/${ClassID}/${item?.id}`}
                                >
                                  <i className="far fa-eye me-2" />
                                  Attendance
                                </Link>
                                <Link
                                  className="dropdown-item"
                                  to={`/user/admin/classes/${ClassID}/courses/${item?.id}/exams`}
                                >
                                  <i className="fas fa-clipboard-list me-2"></i>
                                  Exams
                                </Link>
                                <Link
                                  onClick={() => {
                                    handleOpenDeleteDialog(item?.id);
                                  }}
                                  className="dropdown-item"
                                >
                                  <i className="far fa-trash-alt me-2" />
                                  Delete
                                </Link>
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="card-middle">
                          <span className="card-middle-avatar">
                            {item?.CourseName?.toUpperCase()}
                          </span>
                          <span>
                            Teacher:{" "}
                            {`${item?.Teacher.FirstName} ${item?.Teacher.LastName}`}
                          </span>
                        </div>
                        <div className="card-body">
                          <div className="card-first-row">
                            {AuthUser?.UserType === "admin" && (
                              <Link
                                to={`/user/admin/classes/courses/update/${item?.id}`}
                                className="dropdown-item"
                              >
                                <i className="far fa-edit link-icon" />
                                Edit
                              </Link>
                            )}

                            {AuthUser?.UserType === "admin" && (
                              <Link
                                onClick={() => {
                                  handleOpenDeleteDialog(item?.id);
                                }}
                                className="dropdown-item text-end"
                              >
                                <i className="far fa-trash-alt link-icon" />
                                Delete
                              </Link>
                            )}
                          </div>

                          <div className="card-second-row">
                            {AuthUser?.UserType === "admin" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/admin/classes/courses/attendance/${ClassID}/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                Attendance
                              </Link>
                            ) : AuthUser?.UserType === "student" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/student/classes/courses/attendance/${ClassID}/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                Attendance
                              </Link>
                            ) : AuthUser?.UserType === "teacher" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/teacher/classes/courses/attendance/${ClassID}/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                Attendance
                              </Link>
                            ) : AuthUser?.UserType === "parent" ? (
                              <Link
                                className="dropdown-item"
                                to={`/user/parent/classes/courses/attendance/${ClassID}/${item?.id}`}
                              >
                                <i className="far fa-eye link-icon" />
                                Attendance
                              </Link>
                            ) : (
                              ""
                            )}

                            {AuthUser?.UserType === "admin" ? (
                              <Link
                                className="dropdown-item text-end"
                                to={`/user/admin/classes/${ClassID}/courses/${item?.id}/exams`}
                              >
                                <i className="fas fa-clipboard-list link-icon"></i>
                                Exams
                              </Link>
                            ) : AuthUser?.UserType === "student" ? (
                              <Link
                                className="dropdown-item text-end"
                                to={`/user/student/classes/${ClassID}/courses/${item?.id}/exams`}
                              >
                                <i className="fas fa-clipboard-list link-icon"></i>
                                Exams
                              </Link>
                            ) : AuthUser?.UserType === "teacher" ? (
                              <Link
                                className="dropdown-item text-end"
                                to={`/user/teacher/classes/${ClassID}/courses/${item?.id}/exams`}
                              >
                                <i className="fas fa-clipboard-list link-icon"></i>
                                Exams
                              </Link>
                            ) : AuthUser?.UserType === "parent" ? (
                              <Link
                                className="dropdown-item text-end"
                                to={`/user/parent/classes/${ClassID}/courses/${item?.id}/exams`}
                              >
                                <i className="fas fa-clipboard-list link-icon"></i>
                                Exams
                              </Link>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
            </div>

            {CoursesArray?.length === 0 && <NoDataFound />}
          </div>
        )}
      </div>
      {/* /Page Wrapper */}

      <ActionConfirmation
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this course?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
    </Fragment>
  );
};

export default CoursesListing;
